
export class ParamUtils {

    public static parseNumber(param: string,
                              handler: (resultParam: number) => void,
                              missingHandler?: () => void,
                              notNumberHandler?: (resultParam: string) => void) {
        // Convert to number
        const id: number = +param;
        if (param == null || param.length === 0) {
            if (missingHandler) {
                missingHandler();
            }
        } else if (param.trim().length === 0) {
            // Only whitespaces
            if (missingHandler) {
                missingHandler();
            }
        } else if (isNaN(id)) {
            if (notNumberHandler) {
                notNumberHandler(param);
            } else if (missingHandler) {
                missingHandler();
            }
        } else {
            handler(id);
        }
    }

    public static parseString(param: string,
                              handler: (resultParam: string) => void,
                              missingHandler?: () => void) {

        if (param == null || param.length === 0) {
            if (missingHandler) {
                missingHandler();
            }
        } else if (param.trim().length === 0) {
            // Only whitespaces
            if (missingHandler) {
                missingHandler();
            }
        } else {
            handler(param);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/param-utils.ts